<template>
  <div class="mt-5 col-11 m-5">
    <b-card title="Analysis Data">
      <b-card-text class="mt-3">
        RBPTD provide the analysis data in this page. All the data file are formatted with csv file(separated by comma).
      </b-card-text>
      <b-card v-for="item in items" :key="item.name" style="border:none">
        <template v-slot:header>
          <h6 class="mb-2">
            <b-button variant="primary" :href="item.url">Results of {{item.name}}</b-button>
          </h6>
        </template>
        <b-card-text class="mt-3">{{item.desc}}</b-card-text>
      </b-card>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'download',
  data: function () {
    return {
      items: [
        {
          name: 'RBPs list',
          url: 'static/RBPslist.csv',
          desc: 'The list of RBPs in RBPTD we collecting.'
        },
        {
          name: 'Primary Results',
          url: 'static/tinfo.csv',
          desc: 'The main result data in RBPTD Include the result of differential expression analysis, survival analysis and CNV analysis.'
        },
        {
          name: 'Differential Expression Analysis',
          url: 'static/dea.csv',
          desc: 'The result of differential expression analysis across 28 types of cancer.'
        },
        {
          name: 'Survival Analysis',
          url: 'static/survival.csv',
          desc: 'The survival analysis result using R packages: survival.'
        },
        {
          name: 'CNV Analysis',
          url: 'static/CNV.csv',
          desc: 'The analysis result of GISTIC2.0.'
        },
        {
          name: 'Coexpression analysis',
          url: 'static/co.csv',
          desc: 'Correlation analysis of RBPs and Genes expression. One line per RBP and the first two columns is primary site and RBP. The 3rd columns means the information about target genes separated by "%", the information of each target gene is formatted to "Ensembl ID:symbol:Pearson Correlation Coefficient:p value"'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Download.vue